const root = document.createElement("div");
root.id = "closer-root";
root.style.display = "block";
root.style.visibility = "visible";
document.body.appendChild(root);

const shadow = root.attachShadow({ mode: "open" });

const overlay = document.createElement("div");
overlay.style.position = "fixed";
overlay.style.top = "0";
overlay.style.right = "0";
overlay.style.bottom = "0";
overlay.style.left = "0";
overlay.style.width = "100vw";
overlay.style.height = "100vh";
overlay.style.pointerEvents = "none";
overlay.style.zIndex = "99999999999";
shadow.appendChild(overlay);

const buttonWrapper = document.createElement("div");
buttonWrapper.style.position = "absolute";
buttonWrapper.style.bottom = `0`;
buttonWrapper.style.right = `0`;
buttonWrapper.style.height = `100px`;
buttonWrapper.style.width = `200px`;
buttonWrapper.style.border = "1px solid red";
buttonWrapper.style.overflow = "hidden";
buttonWrapper.style.pointerEvents = "all";
overlay.appendChild(buttonWrapper);

const button = document.createElement("div");
button.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M36 54c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18Zm0 10c15.464 0 28-12.536 28-28S51.464 8 36 8 8 20.536 8 36s12.536 28 28 28Z" fill="url(#a)"/><defs><linearGradient id="a" x1="8" y1="8" x2="64" y2="64" gradientUnits="userSpaceOnUse"><stop stop-color="#2F59C6"/><stop offset="1" stop-color="#2A2A76"/></linearGradient></defs></svg>
`;
button.style.position = "absolute";
button.style.bottom = `10px`;
button.style.right = `50px`;
button.style.height = `72px`;
button.style.width = `72px`;
button.style.border = "1px solid red";
button.style.overflow = "hidden";
button.style.pointerEvents = "all";
button.style.cursor = "pointer";
buttonWrapper.appendChild(button);

const buttonBackground = document.createElement("div");
buttonBackground.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="none"><circle opacity=".5" cx="36" cy="36" r="32" fill="#2A2A76"/></svg>
`;
buttonBackground.style.position = "absolute";
buttonBackground.style.bottom = `10px`;
buttonBackground.style.right = `50px`;
buttonBackground.style.height = `72px`;
buttonBackground.style.width = `72px`;
buttonBackground.style.border = "1px solid red";
buttonBackground.style.overflow = "hidden";
buttonBackground.style.pointerEvents = "all";
buttonBackground.style.cursor = "pointer";
buttonWrapper.appendChild(buttonBackground);

import {
  wrapper as classicChatWrapper,
  chat as classicChat,
} from "./classic-chat";
document.body.appendChild(classicChatWrapper);

const win = window as any;
win.clsr = {
  async init(args: { orgId: string }) {
    const { apiKey } = await (
      await fetch(
        `${new URL(import.meta.url).origin}/api/token?orgId=${args.orgId}`,
      )
    ).json();
    win.closer = {
      q: [
        {
          method: "init",
          args: [
            {
              orgId: args.orgId,
              apiKey,
              showButton: false,
              initializeBeforeRender: true,
              container: `#${classicChat.id}`,
            },
          ],
        },
      ],
    };
    const script = document.createElement("script");
    script.src = "https://widget.demo.closer.app/widget.js";
    (document.head || document.documentElement).appendChild(script);
    setInterval(() => {
      if (win.closer.hideButton) win.closer.hideButton();
      const gorgiasButton =
        document.querySelector<HTMLIFrameElement>("iframe#chat-button");
      if (gorgiasButton) {
        gorgiasButton.style.right = "unset";
      }
    }, 500);
  },
};

if (window.location.hostname === "localhost") {
  win.clsr.init({ orgId: "31e96f41-ebb7-4f7f-8c09-9f82b9ff046a" });
}
